export const config = {
  appLanguage: "ru",
};
